import { createSlice } from '@reduxjs/toolkit';
import { addCrudCases } from '../../store/addCrudCases';
import { personThunks } from './personThunks';
import type { PersonState } from './personTypes';

const initialState: PersonState = { items: [], byId: {}, currentItem: null, status: 'idle', error: null, totalCount: 0 };

export const personSlice = createSlice({
  name: 'persons',
  initialState,
  reducers: {
    clearCurrentPerson(state) { state.currentItem = null; },
  },
  extraReducers: (builder) => {
    addCrudCases(builder, personThunks, (p) => p.personId);
  },
});

export const { clearCurrentPerson } = personSlice.actions;
export const personReducer = personSlice.reducer;
